export const validateEmail = (email: string): boolean => {
    // Keep the dotted-domain contract used by the lookup API.
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    
    if (!emailRegex.test(email)) {
        return false;
    }

    try {
        // Use built-in URL parser as additional validation
        const url = new URL(`mailto:${email}`);
        return url.protocol === "mailto:";
    } catch {
        return false;
    }
};

export const sanitize = (value: string): string => {
    return value.replace(/[^a-zA-Z0-9._@-]/g, '');
};

// Preserves characters permitted in an RFC 5322 email (local + domain parts)
// so that plus-addressing (e.g. "name+tag@domain.com") survives input handling.
export const sanitizeEmail = (value: string): string => {
    return value.replace(/[^a-zA-Z0-9.!#$%&'*+/=?^_`{|}~@-]/g, '');
};

export const isValidUUID = (value: string): boolean => {
    return /^[a-zA-Z0-9]{20}$/.test(value);
};